/**
 * @generated SignedSource<<9c23f978bdd978747d5cc7166b3e16ae>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StandaloneSiteStatus = "ACTIVE" | "DISABLED" | "DRAFT";
export type StandaloneSiteCreateInput = {
  description?: string | null;
  domain?: string | null;
  name: string;
  salesChannelID: number;
  shopifyHeadlessStorefrontToken?: string | null;
};
export type createStandaloneSiteDialogMutation$variables = {
  input: StandaloneSiteCreateInput;
};
export type createStandaloneSiteDialogMutation$data = {
  readonly createStandaloneSite: {
    readonly domain: string | null;
    readonly id: string;
    readonly name: string;
    readonly standaloneSiteID: number;
    readonly status: StandaloneSiteStatus;
  };
};
export type createStandaloneSiteDialogMutation = {
  response: createStandaloneSiteDialogMutation$data;
  variables: createStandaloneSiteDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StandaloneSiteInfo",
    "kind": "LinkedField",
    "name": "createStandaloneSite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "standaloneSiteID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "domain",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createStandaloneSiteDialogMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "createStandaloneSiteDialogMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "87e6cf3913cab20563857159fb98997f",
    "id": null,
    "metadata": {},
    "name": "createStandaloneSiteDialogMutation",
    "operationKind": "mutation",
    "text": "mutation createStandaloneSiteDialogMutation(\n  $input: StandaloneSiteCreateInput!\n) {\n  createStandaloneSite(input: $input) {\n    id\n    standaloneSiteID\n    name\n    domain\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "f61dd1b6c34368be5660e01a1adf9505";

export default node;
